import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import { fetchTransactionList } from "../../redux/feature/manufacturing_app/commonTransactionListSlice";
import { useDispatch, useSelector } from "react-redux";
import { toastFunc } from "../../components/common/util";
import Constants from "../../common/Constants";

export const TransactionList = (props) => {
  const [rowsdata, setRowsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let jobcardListData = useSelector((state) => state?.transactionList?.page?.generatejobcard); // User Details from Store

  const fetchUsers = async (page) => {
    setLoading(true);
    let param = {};
    param.page = page;
    param.perPage = Constants.PER_PAGE;
    param.name = props.name;
    param.method = props.pageURL;

    dispatch(fetchTransactionList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.delete_success_message"),
          2000
        );
      }
      setRowsData(res.payload.items);
      setTotalRows(res.payload.totalCount);
      setLoading(false);
    });
  };

  const searchJobcard = async (page) => {
    setLoading(true);
    let param = {};
    param.page = page;
    param.perPage = Constants.PER_PAGE;
    param.name = props.name;
    param.method = props.pageURL;
    param.filter = props.filterValue;

    dispatch(fetchTransactionList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.delete_success_message"),
          2000
        );
      }
      setRowsData(res.payload.items);
      setTotalRows(res.payload.totalCount);
      setLoading(false);
    });
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let param = {};
    param.page = page;
    param.perPage = newPerPage;
    param.name = props.name;
    param.method = props.pageURL;

    dispatch(fetchTransactionList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.delete_success_message"),
          2000
        );
      }
      setRowsData(res.payload.items);
      setTotalRows(res.payload.totalCount);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (Array.isArray(props?.filterValue) && props.filterValue.length > 0) {
      fetchUsers(1); // fetch page 1 of users
    } else {
      searchJobcard(1);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {  
    if (Array.isArray(props?.filterValue) && props.filterValue.length > 0) {
      fetchUsers(1); // fetch page 1 of users
    } else {
      searchJobcard(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.filterValue]);

  useEffect(() => {
    setRowsData(jobcardListData?.items);
    setTotalRows(jobcardListData?.totalCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobcardListData]);

  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Card>
          <Card.Body>
            <DataTable
              // title={props.pageName}
              columns={props.columnsData}
              data={rowsdata}
              progressPending={loading}
              paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
            />
          </Card.Body>
        </Card>
      </Accordion>
    </div>
  );
};
TransactionList.defaultProps = {
  cardHeader: true,
};
export default TransactionList;
